// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class PromptModalModule {
}
PromptModalModule.ɵfac = function PromptModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PromptModalModule)(); };
PromptModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PromptModalModule });
PromptModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, LoadingSymbolModule, ModalBaseModule] });
